class BodyScrollLockClass {
  private scrollPosition = 0;
  private body: HTMLElement | null;
  private readonly DISABLE_SCROLLING_CLASS: string = 'scroll-disabled';

  constructor() {
    this.body = document.querySelector('body');
  }

  public enable(): void {
    this.scrollPosition = window.scrollY;

    if (this.body) {
      this.body.classList.add(this.DISABLE_SCROLLING_CLASS);
      this.body.style.top = `-${this.scrollPosition}px`;
    }
  }

  public disable(): void {
    if (this.body) {
      this.body.classList.remove(this.DISABLE_SCROLLING_CLASS);
      this.body.style.removeProperty('top');
    }

    window.scrollTo(0, this.scrollPosition);
  }
}

export default new BodyScrollLockClass();
